// angular imports
import { Component, EventEmitter, Injector, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

// cc-common imports
import { Utils } from 'cc-common';

// component imports
import { WorkOrderBaseComponent } from '../../_base/work-order-base-component';

// model imports
import { WorkOrderResultDto } from '../../_models/work-order-result-dto';
import { BasePropertyParametersDto } from '../../_models/base-property-parameter-dto';

@Component({
    selector: 'app-open-work-orders',
    templateUrl: './open-work-orders.component.html',
    styleUrls: ['./open-work-orders.component.scss']
})
export class OpenWorkOrdersComponent extends WorkOrderBaseComponent implements OnInit, OnChanges {
    @Input() communityId: number;
    @Input() isPopup = false;
    @Input() vendorId: number;
    @Input() workOrderIds: Array<number> = [];
    @Input() selectedWorkOrderId: number = null;
    @Input() customerId: string;
    @Input() workflowId: number = null;
    @Input() showOnlyLinked = false;

    @Output() onWorkOrderSelection = new EventEmitter<number[]>();
    @Output() onWorkOrderDeselection = new EventEmitter<number[]>();

    openWorkOrders: Array<WorkOrderResultDto> = [];

    constructor(protected readonly injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        this.populateOpenWorkOrders(true);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (Utils.notNullOrEmpty(changes.communityId) && Utils.notNullOrEmpty(changes.communityId.currentValue)) {
            this.communityId = changes.communityId.currentValue;
            this.populateOpenWorkOrders();
        }
    }

    forceRefresh(): void {
        this.populateOpenWorkOrders(true);
    }

    onWorkOrderRecordsSelection(records: Array<number>): void {
        this.onWorkOrderSelection.emit(records);
    }

    onWorkOrderRecordsDeselection(records: Array<number>): void {
        this.onWorkOrderDeselection.emit(records);
    }

    private populateOpenWorkOrders(clearCache = false): void {
        const baseParams: BasePropertyParametersDto = new BasePropertyParametersDto();
        baseParams.communityId = this.communityId;
        baseParams.customerId = this.customerId;
        baseParams.workflowId = this.workflowId;
        if (Utils.notNullAndDefined(this.vendorId)) {
            baseParams.managementCompanyVendorId = this.vendorId;
        }

        baseParams.clearCache = clearCache;

        this.workOrderHelperService.showLoading();
        this.workOrderService.getOpenWorkOrders(baseParams).subscribe(
            (workOrders: WorkOrderResultDto[]) => {
                let openWorkOrders = Utils.isNullOrUndefined(this.selectedWorkOrderId)
                    ? workOrders
                    : workOrders.filter((d) => Utils.equals(d.workOrderId, this.selectedWorkOrderId));
                if (
                    Utils.isTrue(this.showOnlyLinked) &&
                    Utils.notNullOrEmpty(this.workOrderIds) &&
                    Utils.notNullOrEmpty(openWorkOrders)
                ) {
                    openWorkOrders = openWorkOrders.filter((d) => Utils.isInList(d.workOrderId, this.workOrderIds));
                }

                // Adding below logic if workorder is newly added from Workflow.
                if (Utils.notNullOrEmpty(this.workflowId)) {
                    const wOrders = openWorkOrders.map((d) => {
                        if (Utils.isInList(this.workflowId, d.invoiceIds)) {
                            return d.workOrderId;
                        }
                        return null;
                    });
                    this.workOrderIds = Utils.uniqueList(this.workOrderIds.concat(wOrders));
                }

                this.openWorkOrders = openWorkOrders;
                this.workOrderHelperService.hideLoading();
            },
            (error) => {
                this.errorService.displayError(error);
                this.workOrderHelperService.hideLoading();
            }
        );
    }
}
